if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        // Skip if no URL is provided (e.g., when using custom collection)
        if (!this.dataset.url) return;

        // Hydrate strictly once per mount. complete-the-set-loader.js manages
        // its own variant-change re-fetch path and swaps innerHTML directly —
        // if that fires during / after our initial lazy fetch, we don't want
        // to race or re-fetch over the top of its content. Set the marker
        // before fetch so a mid-flight failure leaves the skeleton visible
        // (page reload is the recovery) rather than re-entering this path.
        if (this.dataset.hydrated) return;
        this.dataset.hydrated = 'true';

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations && recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations && recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block').remove();
              } else {
                this.closest('.shopify-section').remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
            // Transient failure — clear the hydrated marker and schedule a
            // bounded retry. Without this, the skeleton stays visible for the
            // rest of the page lifecycle and only a full reload recovers.
            delete this.dataset.hydrated;
            const attempts = parseInt(this.dataset.hydrateRetries || '0', 10);
            if (attempts < 2) {
              this.dataset.hydrateRetries = String(attempts + 1);
              setTimeout(() => {
                if (!this.dataset.hydrated && this.isConnected) this.init();
              }, 5000 * (attempts + 1));
            }
          });
      }
    }
  );
}
